"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrevious = usePrevious;
exports.useLoading = useLoading;
exports.useLoadingAction = useLoadingAction;
var react_1 = require("react");
function usePrevious(value) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
}
function useLoading() {
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setLoading = _a[1];
    function loadWhileAsync(callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, loadWhilePromise(callback())];
            });
        });
    }
    function loadWhilePromise(promise) {
        return __awaiter(this, void 0, void 0, function () {
            var res, er_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, promise];
                    case 2:
                        res = _a.sent();
                        setLoading(false);
                        return [2 /*return*/, res];
                    case 3:
                        er_1 = _a.sent();
                        setLoading(false);
                        throw er_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return { isLoading: isLoading, loadWhileAsync: loadWhileAsync, loadWhilePromise: loadWhilePromise };
}
/*
  ToDo: Should probably use useCallback()
*/
function useLoadingAction(callback) {
    var loader = useLoading();
    var _a = (0, react_1.useState)(null), error = _a[0], setError = _a[1];
    var _b = (0, react_1.useState)(undefined), latestValue = _b[0], setLatestValue = _b[1];
    var isError = error !== null;
    function trigger(args) {
        return __awaiter(this, void 0, void 0, function () {
            var res, er_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (loader.isLoading) {
                            throw new Error("Already loading");
                        }
                        return [4 /*yield*/, loader.loadWhileAsync(function () { return callback(args); })];
                    case 1:
                        res = _a.sent();
                        setLatestValue(res);
                        setError(null);
                        return [2 /*return*/, res];
                    case 2:
                        er_2 = _a.sent();
                        setError(er_2);
                        throw er_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function triggerSafely(args) {
        if (loader.isLoading) {
            return Promise.resolve(undefined);
        }
        return trigger(args);
    }
    return {
        trigger: trigger,
        isLoading: loader.isLoading,
        isError: isError,
        error: error,
        latestValue: latestValue,
        triggerSafely: triggerSafely,
    };
}
